import React, { useEffect, useMemo } from "react";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import { useSession } from "next-auth/react";
import { useCheckBreakPoint } from "./usResponsive";
import { usePathname } from "next/navigation";
import "../dist/driver.css";

export function validasiOnlyRouteUseFeatureTour(pathname, isBoolean) {
  /**
   * available == '/' -> home
   * available == '/products/' -> detail products
   * available == '/cart' -> cart & checkout
   */

  let value = !isBoolean ? "" : false;

  let newPathname = pathname?.split("/");
  if (newPathname[1] == "products" && newPathname?.length > 2)
    value = !isBoolean ? "detail-produk" : true;
  else if (pathname == "/") value = !isBoolean ? "home" : true;
  else if (newPathname[1] == "cart" && newPathname?.length > 2)
    value = !isBoolean ? "checkout" : true;
  else if (pathname == "/cart") value = !isBoolean ? "cart" : true;

  return value;
}

export default function useDriveJs(page) {
  let breakpoint = useCheckBreakPoint();
  const { data: session, status } = useSession();
  const pathname = usePathname();

  let datasTour = useMemo(() => {
    return {
      home: [
        {
          element: "#kategori",
          popover: {
            title: `Kategori`,
            description: `Arahkan kursor untuk melihat kategori produk di Gudang Online Nibras`
          }
        },
        {
          element: "#search",
          popover: {
            title: `Kolom Pencarian`,
            description: `Cari produk by nama atau warna apapun dengan mengetikan kata kunci disini`
          }
        },
        {
          element: "#cart",
          popover: {
            title: `Keranjang Belanja`,
            description: `Klik untuk mengetahui daftar produk yang sudah ada di keranjang belanja kamu`
          }
        },
        {
          element: "#profile",
          popover: {
            title: `Profile`,
            description: `Arahkan kursor untuk mengunjungi halaman profile dan dashboard penjualan`
          }
        },
        {
          element: "#koleksi-produk",
          popover: {
            title: `Koleksi Produk`,
            description: `Temukan produk menarik dari Gudang Online Nibras disini`
          }
        },
        {
          element: "#chatCS",
          popover: {
            title: `Kontak Admin`,
            description: `Klik untuk menghubungi Admin melalui WhatsApp`
          }
        }
      ],
      "detail-produk": [
        {
          element: "#nama-produk",
          popover: {
            title: `Nama Produk`,
            description: `Lihat disini untuk mengecek nama produk.`
          }
        },
        {
          element: "#harga",
          popover: {
            title: `Harga Produk`,
            description: `Cek harga produk disini, harga yang dicoret merupakan harga normal.`
          }
        },
        {
          element: "#varian",
          popover: {
            title: `Varian Produk`,
            description: `Pilih varian warna sebelum memilih ukuran`
          }
        },
        {
          element: "#size",
          popover: {
            title: `Size Produk`,
            description: `Pilih size produk, angka yang muncul adalah stok tersedia dari varian dan size yang dipilih`
          }
        },
        {
          element: "#jumlah-produk",
          popover: {
            title: `Jumlah Produk`,
            description: `Atur jumlah produk yang mau kamu beli disini`
          }
        },
        {
          element: "#stok-tersedia",
          popover: {
            title: `Stok Tersedia`,
            description: `Cek disini untuk melihat jumlah stok yang masih tersedia`
          }
        },
        {
          element: "#share-produk",
          popover: {
            title: `Bagikan Produk`,
            description: `Kamu bisa bagikan produk ke sosial media kamu dengan klik icon disini`
          }
        },
        {
          element: "#deskripsi-produk",
          popover: {
            title: `Deskripsi Produk`,
            description: `Cek disini untuk melihat deskripsi produk`
          }
        },
        {
          element: "#size-chart-produk",
          popover: {
            title: `Size Chart Produk`,
            description: `Cek disini untuk melihat list ukuran produk`
          }
        },
        {
          element: "#tambah-keranjang",
          popover: {
            title: `Tambah Produk ke Keranjang`,
            description: `Kamu bisa menambahkan produk ke keranjang terlebih dahulu sebelum checkout.`
          }
        },
        {
          element: "#beli-sekarang",
          popover: {
            title: `Beli Sekarang`,
            description: `Kamu bisa membeli produk langsung tanpa menambahkan ke Keranjang Belanja terlebih dahulu`
          }
        }
      ],
      cart: [
        {
          element: "#cart-list-produk",
          popover: {
            title: `Daftar Produk`,
            description: `Produk yang sudah kamu tambah ke keranjang akan muncul disini`
          }
        },
        {
          element: "#voucher",
          popover: {
            title: `Kode Kupon`,
            description: `Masukkan kode voucher disini jika ada promo menarik dari Gudang Online Nibras`
          }
        },
        {
          element: "#jumlah-produk",
          popover: {
            title: `Jumlah Belanjaan`,
            description: `Cek jumlah produk yang kamu beli disini`
          }
        },
        {
          element: "#berat-total",
          popover: {
            title: `Berat Belanjaan`,
            description: `Cek berat belanjaan kamu disini`
          }
        },
        {
          element: "#total-harga",
          popover: {
            title: `Total Harga Belanjaan`,
            description: `Cek total belanjaan kamu disini`
          }
        },
        {
          element: "#checkout",
          popover: {
            title: `Checkout`,
            description: `Klik untuk melanjutkan ke proses berikutnya`
          }
        },
        {
          element: "#tambah-produk",
          popover: {
            title: `Tambah Produk`,
            description: `Klik disini untuk menambahkan produk lain ke keranjang belanja`
          }
        }
      ],
      checkout: [
        {
          element: "#informasi-pengirim",
          popover: {
            title: `Informasi Pengirim`,
            description: `Informasi ini akan ditampilkan sebagai data pengirim pada resi pengiriman`
          }
        },
        {
          element: "#informasi-penerima",
          popover: {
            title: `Informasi Penerima`,
            description: `Isi informasi alamat penerima/pembeli disini. Pastikan alamat sesuai untuk memudahkan kurir mengirim paket`
          }
        },
        {
          element: "#pilih-alamat",
          popover: {
            title: `Pilih Alamat`,
            description: `Jika kamu mau mengirim ke alamat yang pernah digunakan, kamu bisa gunakan fitur ini untuk memilih kembali alamat tersebut.`
          }
        },
        {
          element: "#daftar-belanjaan",
          popover: {
            title: `List Belanjaan Kamu`,
            description: `Kamu bisa mengecek kembali nama produk dan jumlah produk disini.`
          }
        },
        {
          element: `#catatan`,
          popover: {
            title: `Catatan Pesanan`,
            description: `Klik untuk menambah catatan pesanan anda.`
          }
        },
        {
          element: `#resi-${process.env.COMPANY_NAME}`,
          popover: {
            title: `Resi ${process.env.COMPANY_NAME}`,
            description: `Resi ini secara otomatis terpilih jika kamu melakukan transaksi di platform ${process.env.COMPANY_NAME}.`
          }
        },
        {
          element: "#resi-marketplace",
          popover: {
            title: `Resi Marketplace`,
            description: `Centang Resi Marketplace jika kamu memiliki pesanan yang masuk dan dikirim melalui Marketplace`
          }
        },
        {
          element: "#proses-pesanan",
          popover: {
            title: `Proses Pesanan Kamu`,
            description: `Jika semua data sudah dipastikan diisi dan benar, kamu bisa langsung proses pesanan kamu dengan klik tombol Proses Pesanan`
          }
        }
      ]
    };
  }, [page]);

  useEffect(() => {
    let keyTour = validasiOnlyRouteUseFeatureTour(pathname);

    if (!page || !session?.user?.data?.mitra_id || page !== keyTour) return;

    // validasi mobile ui ux
    if (breakpoint == "ui-phone") {
      let isIndex = datasTour[page].findIndex((a) => a?.element == `#kategori`);
      if (isIndex >= 0) datasTour[page].splice(isIndex, 1);
    }

    // Initialize or use drive.js functions here
    const driverObj = driver({
      showProgress: true,
      steps: datasTour[page],
      popoverClass: "driverjs-theme"
    });

    setTimeout(
      function () {
        if (status == "authenticated") {
          let validFeatureTour =
            JSON.parse(
              localStorage.getItem(
                `feature-tour-${session?.user?.data?.mitra_id}-${page}`
              )
            ) || false;
          if (validFeatureTour) return;
          driverObj?.drive();
          localStorage.setItem(
            `feature-tour-${session?.user?.data?.mitra_id}-${page}`,
            true
          );
          sessionStorage.setItem("hidden-feature-tour", false);
        }
      },
      breakpoint == "ui-phone" ? 3000 : 1000
    ); // Delay of 1-2 seconds
  }, [page, status, session, breakpoint, pathname]);

  return null;
}

export function dompetDigitalTopUpDriverJS(step = 0) {
  const localdompetDigitalTopUpDriverJS = localStorage.getItem(
    "dompetDigitalTopUpDriverJS"
  );

  if (localdompetDigitalTopUpDriverJS == "1") return;
  // Initialize or use drive.js functions here
  const driverObj = driver({
    showProgress: false,
    allowClose: false,
    popoverClass: "driverjs-theme",
    onDestroyStarted: () => {
      if (!driverObj.hasNextStep() || confirm("Are you sure?")) {
        driverObj.destroy();
        localStorage.setItem("dompetDigitalTopUpDriverJS", "1");
      }
    }
  });

  if (step == 0) {
    driverObj.highlight({
      element: "#highlight-me-topup",
      popover: {
        side: "bottom",
        title: "Top Up",
        description:
          "Klik di sini untuk melakukan pengisian saldo ke dompet kamu."
      }
    });
  } else if (step == 1) {
    driverObj.destroy();
    driverObj.setSteps([
      {
        element: "#nominal-topup",
        popover: {
          title: "Nominal Top Up",
          description: "Masukkan jumlah nominal yang ingin kamu isi."
        }
      },
      {
        element: "#metode-pembayaran",
        popover: {
          title: "Metode Pembayaran",
          description: "Pilih metode pembayaran yang ingin kamu gunakan."
        }
      },
      {
        element: "#btn-handle-topup",
        popover: {
          title: "Top Up Sekarang",
          description: "Klik tombol ini untuk melanjutkan ke proses berikutnya."
        }
      }
    ]);
    setTimeout(() => {
      driverObj.drive();
    }, 1000);
  }

  return driverObj;
}

export function dompetDigitalWithdrawDriverJS(step = 0) {
  const localdompetDigitalWithdrawDriverJS = localStorage.getItem(
    "dompetDigitalWithdrawDriverJS"
  );

  if (localdompetDigitalWithdrawDriverJS == "1") return;
  // Initialize or use drive.js functions here
  const driverObj = driver({
    showProgress: false,
    allowClose: false,
    popoverClass: "driverjs-theme",
    onDestroyStarted: () => {
      if (!driverObj.hasNextStep() || confirm("Are you sure?")) {
        driverObj.destroy();
        localStorage.setItem("dompetDigitalWithdrawDriverJS", "1");
      }
    }
  });

  if (step == 0) {
    driverObj.highlight({
      element: "#highlight-me-withdraw",
      popover: {
        side: "bottom",
        title: "Tarik Wallet",
        description:
          "Klik di sini untuk melakukan penarikan saldo dari dompet kamu."
      }
    });
  } else if (step == 1) {
    driverObj.destroy();
    driverObj.setSteps([
      {
        element: "#pilih-bank",
        popover: {
          title: "Bank",
          description:
            "Masukkan bank yang ingin kamu tuju untuk penarikan saldo ini."
        }
      },
      {
        element: "#tambah-bank",
        popover: {
          title: "Tambah Bank",
          description: "Klik di sini untuk menambahkan bank baru."
        }
      },
      {
        element: "#nominal-withdraw",
        popover: {
          title: "Nominal Penarikan",
          description: "Masukkan jumlah nominal yang ingin kamu tarik."
        }
      },
      {
        element: "#btn-handle-withdraw",
        popover: {
          title: "Tarik Sekarang",
          description: "Klik tombol ini untuk memproses penarikan."
        }
      }
    ]);
    setTimeout(() => {
      driverObj.drive();
    }, 1000);
  }

  return driverObj;
}
